import React, { useMemo, useContext } from 'react'
import { ConfigContext } from 'contexts/ConfigContext'
import { Button } from 'react-bootstrap'
import objectPath from 'object-path'
import FeatherIcon from 'feather-icons-react'
import '../score.css'
import dayjs from 'dayjs'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import { checkIsWarning } from '../Validation'

const ShowScore = ({
  uischema,
  score,
  scoreIndex,
  deleteScore,
  editScore,
  warning,
  isReadOnly,
  warningChart,
}) => {
  const { dateFormat } = useTimeFormat()
  const scoreActionUpdate = objectPath.get(uischema, 'scoreAction.update') || {}
  const scoreActionDelete = objectPath.get(uischema, 'scoreAction.delete') || {}
  const fullConfig = objectPath.get(uischema, 'scoreConfig')
  const scoreSetting = objectPath.get(uischema, 'scoreSetting')
  const scoreConfig = fullConfig.filter(
    ({ isDate, isTime }) => !isDate && !isTime
  )

  const configContext = useContext(ConfigContext)
  const { layoutType } = configContext.state

  const colorByTheme = useMemo(
    () => (layoutType === 'dark' ? '#adb7be' : '#495057'),
    []
  )

  const scoreValueStyle = useMemo(() => {
    if (scoreSetting?.scoreWidth) {
      return {
        width: scoreSetting.scoreWidth,
      }
    }
    return {}
  }, [scoreSetting?.scoreWidth])

  const dateChart = useMemo(() => {
    return fullConfig.find(({ isDate, enabled }) => isDate && enabled) || {}
  }, [])

  const timeChart = useMemo(() => {
    return fullConfig.find(({ isTime, enabled }) => isTime && enabled) || {}
  }, [])

  const { isTime } = timeChart
  const { isDate } = dateChart
  const dateName = objectPath.get(dateChart, 'name') || 'time'
  const timeName = objectPath.get(timeChart, 'name') || 'date'
  const dateValue = objectPath.get(score, dateName)
  const timeValue = objectPath.get(score, timeName)

  return (
    <div>
      <div>
        {isDate && (
          <div className="body-box d-flex">
            <div
              className="d-flex border w-100 p-2 align-items-center"
              style={{ color: colorByTheme }}
            >
              {dayjs(dateValue).format(dateFormat)}
            </div>
          </div>
        )}
        {isTime && (
          <div className="body-box d-flex">
            <div
              className="d-flex border w-100 p-2 align-items-center justify-content-center"
              style={{ color: colorByTheme }}
            >
              {timeValue}
            </div>
          </div>
        )}
        <>
          {scoreConfig.map((config) => {
            let { group, name, data, enabled } = config
            let scoreValue = objectPath.get(score, name)
            let isWarning = checkIsWarning(warningChart, name, scoreValue)
            if (!enabled) return
            if (group) {
              return (
                <div>
                  {data.map(({ name, enabled }) => {
                    if (!enabled) return
                    let scoreValue = objectPath.get(score, name)
                    return (
                      <div
                        className={`sub-box ${isWarning ? 'text-danger' : ''}`}
                        style={{ ...scoreValueStyle, color: colorByTheme }}
                      >
                        {scoreValue}
                      </div>
                    )
                  })}
                </div>
              )
            }
            return (
              <div
                className={`sub-box ${isWarning ? 'text-danger' : ''}`}
                style={scoreValueStyle}
              >
                {scoreValue}
              </div>
            )
          })}
        </>
      </div>
      {!isReadOnly && (
        <div className="d-flex align-items-end justify-content-end">
          <div className="d-flex">
            {scoreActionUpdate?.isEnabled && (
              <div className="mb-2">
                <Button
                  className="score-button"
                  variant="outline-warning"
                  onClick={() => editScore(scoreIndex)}
                >
                  <FeatherIcon icon="edit" size="14" />
                </Button>
              </div>
            )}
            {scoreActionDelete?.isEnabled && (
              <div className="mx-1">
                <Button
                  className="score-button"
                  variant="outline-danger"
                  onClick={() => deleteScore(scoreIndex)}
                >
                  <FeatherIcon icon="trash" size="14" />
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
export default ShowScore
